import { z } from 'zod';

export const HiringNotificationEmailSubjectSuffixTemplate = z
  .enum(['GroupByLocation', 'NoSuffix'])
  .describe('HiringNotificationEmailSubjectSuffixTemplate');

export type HiringNotificationEmailSubjectSuffixTemplate = z.infer<
  typeof HiringNotificationEmailSubjectSuffixTemplate
>;
